<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "VFooter",
  data() {
    return {
      current: null,
      open: false,
    };
  },
  provide() {
    return {
      onOpen: this.onCurrent,
      open: () => {
        return this.current;
      },
    };
  },
  methods: {
    onCurrent(i) {
      this.current = i == this.current ? null : i;
    },
  },
};
</script>

<style lang="scss" scoped></style>
